import { useTheme } from 'contexts'
import React from 'react'

import { Box } from 'widgets/Box'

type Props = {
  currentStep: number
  totalSteps: number
}

export const StepsPaginator = ({ currentStep, totalSteps }: Props) => {
  const theme = useTheme()

  const getRenderItem = (index: number) => {
    const color = index < currentStep ? 'v2primary' : 'grey'
    const width = `${100 / totalSteps - totalSteps / (theme.spacing.xs * 2)}%`
    return <Box key={index} height={2} width={width} margin='xs' backgroundColor={color} />
  }

  return (
    <Box flexDirection='row' padding='smd' align='center' justifyContent='center'>
      {[...Array(totalSteps).keys()].map((index) => {
        return getRenderItem(index)
      })}
    </Box>
  )
}
